'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = require('decisiv-ui-utils');

var _decisivIconixReact = require('decisiv-iconix-react');

var _decisivIconixReact2 = _interopRequireDefault(_decisivIconixReact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  small: function small() {
    return '\n    font-size: ' + (0, _decisivUiUtils.px2rem)(16) + ';\n  ';
  },

  secondary: function secondary(_ref) {
    var theme = _ref.theme;
    return '\n    color: ' + theme.colors.base.chrome600 + ' !important;\n  ';
  }
};

// !important is generally discouraged. This use case is specifically for
// when the Avatar is wrapped in some type of Link or Button component
// that applies the blue & underline on hover.
var styles = function styles(_ref2) {
  var theme = _ref2.theme;
  return '\n  color: ' + theme.colors.base.chrome000 + ' !important;\n  font-size: ' + (0, _decisivUiUtils.px2rem)(32) + ';\n  text-decoration: none !important;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome000: _propTypes2.default.string.isRequired,
      chrome600: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Icon', (0, _styledComponents2.default)(_decisivIconixReact2.default), styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/Avatar/Icon.js
// module id = 1532
// module chunks = 2